<template>
   <div class="modal" :id="id" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ title }}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body" v-html="content">

      </div>

    </div>
  </div>
</div>

</template>

<script>
export default {
  name: "Modal",
  props: {
    id: String,
    title: String,
    content: String,
  },
}
</script>
